export const ConsultationEvaluationEn = {
    xunjiadang:'Consultation and evaluation',
    fanhui:'Back',
    wodepingjia:'My evaluation',
    wodezhuiping:'My review',
    daipinjiadingdang:'Order to be evaluated',
    zuanjiaxinxi:'Expert information',
    pingjianeirong:'Evaluation content',
    pingjiazuantai:'Evaluation state',
    wodepingjia:'My evaluation',
    sangjiapingjia:'Merchant evaluation',
    pingtaihuifu:'Platform to reply',
    jiage:'Price',
    zixunjindu:'Evaluation state',
    caozuo:'operation'
}


// WEBPACK FOOTER //
// ./src/lang/member/ConsultationEvaluation/ConsultationEvaluationEn.js